import React, { useEffect, useState, useCallback } from "react";
import "./Home.css";
import { SimpleGrid, Text, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import homeGraphic from "../../Assets/Images/home.png";
import { useTheme } from "../ThemeContext/ThemeContext";
import { useWorldData } from "../../context/WorldContext";
import { getUserProgress } from "../../utils/userUtils";
function Home() {
  let navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  //const [worldOrder, setWorldOrder] = useState("");
  //const [worldId, setWorldId] = useState("");
  const [progressDialogue, setProgressDialogue] = useState("");
  const [canContinueAdventure, setCanContinueAdventure] = useState(true);
  const { currentTheme } = useTheme();
  const {
    currentWorldOrder,
    setCurrentWorldOrder,
    currentWorldId,
    setCurrentWorldId,
  } = useWorldData();
  //Checking the if progress exists
  const progressChecker = useCallback(() => {
    let worldId = "";
    const data = getUserProgress();
    if (data) {
      var worldProgress = data.worldProgresses.find(
        (world) => world.world === data.lastWorld
      );
      if (!worldProgress) {
        setCanContinueAdventure(false);
        setCurrentWorldId(data.worldProgresses[0].world);
        worldId = data.worldProgresses[0].world;
        return;
      }
      if (worldProgress.status == "completed") {
        var nextWorld = data.worldProgresses.find(
          (world) => world.status != "completed"
        );
        if (!nextWorld) {
          setCanContinueAdventure(false);
          setCurrentWorldId(data.worldProgresses[0].world);
          worldId = data.worldProgresses[0].world;
          return;
        }
        worldProgress = nextWorld;
      }
      setCurrentWorldId(worldProgress.world);
      if (worldProgress.nextDialogue !== null) {
        setProgressDialogue(worldProgress.nextDialogue);
      }
      worldId = worldProgress.world;
    } else {
      console.error("Error fetching worldId");
    }
    return worldId;
  }, []);

  //Checking the if progress exists
  const fetchWorldOrder = useCallback(
    (worldId) => {
      setCurrentWorldOrder(worldId);
    },
    [currentWorldId]
  );

  useEffect(() => {
    setIsLoggedIn(true);
    let worldId = progressChecker();
    fetchWorldOrder(worldId);
  }, [progressChecker, fetchWorldOrder]);

  const handleMap = () => {
    navigate("/map");
  };

  const handleContinueWorld = () => {
    if (progressDialogue !== null) {
      navigate("/world", {
        state: {
          worldOrder: currentWorldOrder,
          progressDialogue: progressDialogue,
        },
      });
    } else {
      navigate("/map");
    }
  };

  return (
    <div className="home-container">
      <div className="home-wrapper">
        <div className="home-layout">
          <Text
            className="home-title"
            bgGradient={[
              "linear(to-tr, teal.800, green.800)",
              "linear(to-t, pink.800, blue.800)",
              "linear(to-b, teal.800, purple.700)",
            ]}
            bgClip="text"
            fontWeight="extrabold"
          >
            Gender-Affirming, Life-Affirming:
          </Text>
          <Text
            className="home-subtitle"
            bgGradient={[
              "linear(to-tr, green.800, red.800)",
              "linear(to-t, pink.800, teal.800)",
              "linear(to-b, purple.900, green.800)",
            ]}
            bgClip="text"
            fontWeight="extrabold"
          >
            An online puberty and sexual health resource for gender-independent,
            nonbinary, transgender, and intersex youth.
          </Text>
          <img src={homeGraphic} alt="Home graphic" className="home-graphic" />
          <SimpleGrid
            columns={[1, null, canContinueAdventure ? 2 : 1]}
            spacing="60px"
          >
            <Button
              key="start"
              onClick={handleMap}
              size="lg"
              backgroundColor={currentTheme.color1}
              _hover={{
                bg: currentTheme.color9,
                color: "black",
              }}
              variant="solid"
            >
              Explore Map
            </Button>
            {canContinueAdventure && (
              <Button
                key="continue"
                onClick={handleContinueWorld}
                size="lg"
                backgroundColor={currentTheme.color1}
                _hover={{
                  bg: currentTheme.color9,
                  color: "black",
                }}
                variant="solid"
              >
                Continue your adventure
              </Button>
            )}
          </SimpleGrid>
        </div>
      </div>
    </div>
  );
}

export default Home;
